/**
 * Export Modal Component
 * Requirements: 18.1, 18.2, 18.3, 18.5
 */

import React from 'react';
import { Download, X, FileText, FileSpreadsheet } from 'lucide-react';
import './ExportModal.css';

const ExportModal = ({
  exportFormat,
  setExportFormat,
  exportLoading,
  onExport,
  onClose,
  exportError = null,
  showTypeSelector = false,
  cohortExportType = 'COHORT_DATA',
  setCohortExportType = () => {}
}) => {
  return (
    <div className="export-modal-overlay" onClick={onClose}>
      <div className="export-modal" onClick={(e) => e.stopPropagation()}>
        <div className="export-modal-header">
          <h3 className="export-modal-title">Export Data</h3>
          <button className="export-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="export-modal-content">
          <p className="export-modal-description">
            Select the format for your data export. The file will be generated and ready for download.
          </p>

          {showTypeSelector && (
            <div className="export-format-selector">
              <label className="export-format-label">Report Type</label>
              <div className="export-format-options">
                <button
                  className={`export-format-option ${cohortExportType === 'COHORT_DATA' ? 'active' : ''}`}
                  onClick={() => setCohortExportType('COHORT_DATA')}
                >
                  <FileSpreadsheet size={24} />
                  <div className="export-format-info">
                    <div className="export-format-name">Full Data</div>
                    <div className="export-format-desc">Overview, competencies, heatmap</div>
                  </div>
                </button>

                <button
                  className={`export-format-option ${cohortExportType === 'OGSM_SUMMARY' ? 'active' : ''}`}
                  onClick={() => setCohortExportType('OGSM_SUMMARY')}
                >
                  <FileText size={24} />
                  <div className="export-format-info">
                    <div className="export-format-name">OGSM Summary</div>
                    <div className="export-format-desc">Objective, goal, measures</div>
                  </div>
                </button>
              </div>
            </div>
          )}

          <div className="export-format-selector">
            <label className="export-format-label">Export Format</label>
            <div className="export-format-options">
              <button
                className={`export-format-option ${exportFormat === 'CSV' ? 'active' : ''}`}
                onClick={() => setExportFormat('CSV')}
              >
                <FileText size={24} />
                <div className="export-format-info">
                  <div className="export-format-name">CSV</div>
                  <div className="export-format-desc">Comma-separated values</div>
                </div>
              </button>

              <button
                className={`export-format-option ${exportFormat === 'EXCEL' ? 'active' : ''}`}
                onClick={() => setExportFormat('EXCEL')}
              >
                <FileSpreadsheet size={24} />
                <div className="export-format-info">
                  <div className="export-format-name">Excel</div>
                  <div className="export-format-desc">Microsoft Excel format</div>
                </div>
              </button>
            </div>
          </div>

          {exportLoading && (
            <div className="export-progress">
              <div className="export-progress-bar">
                <div className="export-progress-fill"></div>
              </div>
              <p className="export-progress-text">Generating export file...</p>
            </div>
          )}

          {exportError && !exportLoading && (
            <p className="export-modal-error" style={{ color: '#dc2626', marginTop: '0.75rem', fontSize: '0.875rem' }}>
              {exportError}
            </p>
          )}
        </div>

        <div className="export-modal-footer">
          <button
            className="leading-btn leading-btn-secondary"
            onClick={onClose}
            disabled={exportLoading}
          >
            Cancel
          </button>
          <button
            className="leading-btn leading-btn-primary"
            onClick={onExport}
            disabled={exportLoading}
          >
            {exportLoading ? (
              <>
                <div className="btn-spinner"></div>
                Exporting...
              </>
            ) : (
              <>
                <Download size={18} />
                Export {exportFormat}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportModal;
